var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistanceSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.208,
    height: 9.232,
    viewBox: "0 0 9.208 9.232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_143228",
    "data-name": "Path 143228",
    d: "M4.925,2A2.025,2.025,0,0,0,2.9,4.025V9.2H2.45a.45.45,0,0,0-.318.768l.9.9a.45.45,0,0,0,.636,0l.9-.9A.45.45,0,0,0,4.25,9.2H3.8V4.025a1.125,1.125,0,1,1,2.25,0v4.95a2.025,2.025,0,1,0,4.05,0V4.623a1.35,1.35,0,1,0-.9,0V8.975a1.125,1.125,0,0,1-2.25,0V4.025A2.025,2.025,0,0,0,4.925,2Z",
    transform: "translate(-1.893 -1.9)",
    fill: "#52b33a",
    stroke: "#fff",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistanceSvg);
export default __webpack_public_path__ + "static/media/DistanceSvg.090091390c5e3c1f63ca3ed81e174aa5.svg";
export { ForwardRef as ReactComponent };